/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoBirthdayField implements angular.IDirective {
        private filter: angular.IFilterService;
        restrict = "E";
        scope = {
            currentValue: "=ngModel"
        };

        templateUrl = 'app/components/controls/birthdayFieldTemplate.html';

        constructor($filter: angular.IFilterService) {
            this.filter = $filter;

        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var filter = this.filter;

            console.log("New change");

            scope.birthday = {
                month: "",
                day: "",
                year: ""
            };

            var getDaysInMonth = () => {

                var numberOfDays = 31;
                var days = [];

                if (scope.birthday.month !== undefined && scope.birthday.month !== "") {
                    if (scope.birthday.year !== undefined && scope.birthday.year !== "") {
                        numberOfDays = moment(scope.birthday.year + "-" + scope.birthday.month, "YYYY-MM").daysInMonth();
                    } else {
                        numberOfDays = moment("2000-" + scope.birthday.month, "YYYY-MM").daysInMonth();
                    }
                }
                

                for (var i = 1; i <= numberOfDays; i++) {
                    days.push({ value: i, displayName: i });
                };

                return days;
            };

            var getYears = () => {
                var currentYear = moment().year();
                var years = [];

                for (var i = currentYear - 110; i < currentYear; i++) {
                    years.push({ value: i, displayName: i });
                }

                return years;
            };

            var getMonths = () => {
                var months = [];
                var listOfMonths = moment.months();

                for (var i = 0; i < listOfMonths.length; i++) {
                    months.push({ value: i + 1, displayName: listOfMonths[i] });
                };

                return months;
            };

            scope.months = getMonths();
            scope.days = getDaysInMonth();
            scope.years = getYears();

            scope.$watch('years', () => {
                var selectedDay = scope.birthday.day;
                console.log("selected day: " + selectedDay);
                scope.days = getDaysInMonth();
            });

            scope.$watch('months', () => {
                var selectedDay = scope.birthday.day;
                console.log("selected day: " + selectedDay);
                scope.days = getDaysInMonth();
            });


        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter) => {
                return new MeevoBirthdayField($filter);
            };

            directive.$inject = ["$filter"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoBirthdayField", MeevoBirthdayField.factory());
}